// extracted by mini-css-extract-plugin
export default {"header":"SingleAssetPanel_header__3tUWC","header__asset_type":"SingleAssetPanel_header__asset_type__DJn8W","tabs":"SingleAssetPanel_tabs__yp5uy"};